import React from 'react';

import { flagStyles } from '../settings';

const SvgNZ = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4056px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgNZ;
